import { graphql } from "@opensea/graphql"

export const CreateCollectionOfferTimeline_collectionFragment = graphql(`
  fragment CreateCollectionOfferTimeline_collection on Collection {
    slug
    chain {
      identifier
    }
    address
    imageUrl
  }
`)
